const request = {
    invalid_input: 'Input inválido. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    range_not_satisfiable: 'Intervalo não satisfatório.',
    feature_not_supported: 'Esta funcionalidade não é suportada no ambiente atual.',
};
export default Object.freeze(request);
